import PhotocardItem from './PhotocardItem';

export default PhotocardItem;
